export const colors = {
  transparent: "rgba(0, 0, 0, 0)",
  translucentTan: "rgba(244, 222, 201, 0.7)",
  white: "rgb(255, 255, 255)",
  lightTan: "rgb(205,205,198)",
  tan: "rgb(244, 222, 201)",
  orange: "rgb(152, 108, 67)",
  green: "rgb(54, 64, 55)",
}
